export default __webpack_public_path__ + "static/vision-c0707c8e9da610735451e27b74630248.gif";